import { ExternalLink } from 'lucide-react';
import { ASSETS, CONTACT } from '../constants/site';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-amber-500/10 py-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={ASSETS.icon} alt="GSLAB" className="h-11 w-11 rounded-lg" />
              <div>
                <div className="font-display font-extrabold text-lg leading-none">
                  <span className="text-gradient-gold">GS</span>LAB
                </div>
                <div className="font-mono-tech text-[9px] tracking-[0.3em] text-slate-500 mt-1">CUSTOM WEB & AUTOMATION SYSTEMS</div>
              </div>
            </div>
            <p className="text-xs text-slate-500 font-mono-tech tracking-wider">
              {CONTACT.domain} — SECURED ON CLOUDFLARE EDGE
            </p>
          </div>
          <div className="grid grid-cols-2 gap-x-16 gap-y-2 text-sm">
            <a href={`mailto:${CONTACT.email}`} className="text-slate-400 hover:text-amber-300 transition-colors">{CONTACT.email}</a>
            <a href={CONTACT.portfolio} target="_blank" rel="noreferrer" className="text-slate-400 hover:text-amber-300 transition-colors inline-flex items-center gap-1.5">
              Founder Portfolio <ExternalLink size={12} />
            </a>
            <a href={`tel:${CONTACT.phone}`} className="text-slate-400 hover:text-amber-300 transition-colors">{CONTACT.phone}</a>
            <a href="#pricing" className="text-slate-400 hover:text-amber-300 transition-colors">Pricing</a>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-slate-800/60 flex flex-col sm:flex-row justify-between gap-3">
          <span className="text-xs text-slate-600">© 2026 GSLAB. All rights reserved.</span>
          <span className="text-xs text-slate-600 font-mono-tech tracking-wider">ENGINEERED IN GEORGIA, USA</span>
        </div>
      </div>
    </footer>
  );
}
